<template>
  <KITLayout></KITLayout>
  <q-banner
    v-if="!online"
    class="bg-red text-white"
    style="position: absolute; width: 500px; left: calc(50% - 250px); bottom: 0; z-index: 9999"
    ><template #avatar> <q-icon :name="symOutlinedSignalDisconnected" color="white" size="md" /> </template>Sie sind derzeit offline.
    Änderungen können nicht gespeichert werden.</q-banner
  >
  <!-- <MaterialLayout v-if="preferences.settings?.theme == 'Material'"></MaterialLayout> -->
</template>
<script setup>
import { onBeforeMount } from "vue";
import { useQuasar } from "quasar";
import quasarLangDe from "quasar/lang/de";
import quasarLangEn from "quasar/lang/en-US";
import { useI18n } from "vue-i18n";

import KITLayout from "@/layouts/KIT.vue";
import { usePreferencesStore } from "@/stores/preferences.js";
import { symOutlinedSignalDisconnected } from "@quasar/extras/material-symbols-outlined";
import { useOnline } from "@vueuse/core";
const preferences = usePreferencesStore();
if (!preferences.settings?.theme) {
  preferences.settings.theme = "KIT";
}

const { locale } = useI18n({ useScope: "global" });
const $q = useQuasar();

//$q.addressbarColor.set("#00876C");

const online = useOnline();

onBeforeMount(() => {
  if (preferences.settings?.locale) {
    locale.value = preferences.settings.locale;
    if (locale.value === "de") {
      $q.lang.set(quasarLangDe);
    } else {
      $q.lang.set(quasarLangEn);
    }
  }
});
</script>

<style lang="scss">
@import "@/custom.scss";

.grecaptcha-badge {
  visibility: hidden;
}

.q-layout {
  background-color: rgb(245, 245, 245);

  .body--dark & {
    background-color: #121212 !important;

    &.has-background .glasscard .v-table a {
      color: #90caf9;
    }
  }

  &.bg-information {
    background: url("/assets/background-information.jpg") no-repeat center center fixed;
    background-size: cover;
  }

  &.bg-default {
    background: url("/assets/background.jpg") no-repeat center center fixed;
    background-size: cover;
  }

  &.bg-bg2 {
    background: url("/assets/bg2.jpg") no-repeat center center fixed;
    background-size: cover;
  }

  &.bg-bg3 {
    background: url("/assets/bg3.jpg") no-repeat center center fixed;
    background-size: cover;
  }

  &.bg-bg4 {
    background: url("/assets/bg4.jpg") no-repeat center center fixed;
    background-size: cover;
  }
}

.bg-amber15 {
  background-color: #d99d22 !important;
}

a,
a:visited,
a:hover {
  color: #2196f3;
}

.q-list {
  a,
  a:visited,
  a:hover {
    color: #121212;
  }

  .body--dark & {
    a,
    a:visited,
    a:hover {
      color: #fff;
    }
  }
}

.q-list--dense > .q-item.q-px-none {
  padding-left: 0;
  padding-right: 0;
}

.q-drawer .q-item {
  border-left: 2px solid transparent;
}

.q-drawer .q-list.cp-navbar {
  a,
  a:visited,
  a:hover {
    color: white;
  }
}

.q-drawer .q-item.navbar-menu-group-active,
.navbar-menu-group-active + .q-expansion-item__content {
  color: white;
  border-left: 2px solid $campus-yellow;
}

.navbar-menu-active,
.navbar-menu-active a,
.navbar-menu-active a:visited,
.navbar-menu-active a:hover,
.navbar-menu-active .q-icon {
  color: $campus-yellow !important;
  font-weight: 500;
}

.q-table {
  a,
  a:visited,
  a:hover {
    color: #2196f3;
    text-decoration: none;
    font-weight: 500;
  }

  a.q-btn {
    .body--dark & {
      color: rgb(245, 245, 245);
    }

    color: #121212;
  }

  th {
    white-space: nowrap;
  }

  td {
    line-height: 1rem;
  }
}

.q-select {
  .selected-item {
    font-size: 0.8rem;
    line-height: 0.9rem;
    overflow: hidden;
    display: block;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:first-child {
      margin-top: 6px;
    }
  }
}

.slim-scrollbar {
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.5);
    /* color of the tracking area */
    border-radius: 20px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.5);
    /* color of the scroll thumb */
    border-radius: 20px;
    /* roundness of the scroll thumb */
  }
}

.demo .blurable {
  filter: blur(5px);
}

.prose {
  h2 {
    margin: 2rem 0 0 0;
  }

  h3 {
    margin: 1rem 0 0.3rem 0;
  }

  h2 + h3 {
    margin-top: 0.5rem;
  }

  ul,
  ol {
    padding-left: 2rem;
    margin-bottom: 0.5rem;
  }
}

.q-field--extradense .q-field__control,
.q-field--extradense .q-field__marginal {
  height: 32px !important;
  padding-right: 0;
}
.q-field--tiny .q-field__control,
.q-field--tiny .q-field__marginal {
  height: 24px !important;
  padding-right: 0;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.opacity-50 {
  opacity: 0.5;
}

// Anpassungen an mobile Ansicht
body.screen--xs {
  .q-table--dense .q-table th:first-child,
  .q-table--dense .q-table td:first-child {
    padding-left: 5px;
  }

  .q-table--dense .q-table th,
  .q-table--dense .q-table td {
    padding: 4px;
  }
}

.anim-rotate {
  animation: spin 5s infinite;
}

// Animationen
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>
